module.exports = __webpack_public_path__ + "img/doradzamyauta.bc084e26.webp";